import styled from "@emotion/styled";
import React from "react";
import { TextInput } from "../../form";
import { Checkbox, Radio } from "antd";

const CheckboxWrapper = styled.div(() => ({
  margin: "2rem 0",
  display: "flex",
  flexDirection: "column",
  gap: "3rem",
}));

const ToolWrapper = styled.div(() => ({
  display: "flex",
  flexWrap: "wrap",
  gap: "1rem 1.6rem",
}));

const CampaignCheckBoxGroup = ({
  control,
  checkSNS,
  setCheckSNS,
  errors,
  contactPath,
  setContactPath,
}) => {
  return (
    <CheckboxWrapper>
      <section>
        <label>세이브더얼스 SNS(유튜브 및 인스타그램) 구독 여부 (필수)</label>

        <p style={{ color: "red" }}>
          ※ 팔로우, 구독 확인이 안될 경우, 심사 대상에서 제외됩니다.
        </p>

        <div>
          <Checkbox
            checked={checkSNS.yes}
            onChange={() =>
              setCheckSNS({ yes: !checkSNS.yes, no: checkSNS.yes })
            }
          >
            예
          </Checkbox>

          <Checkbox
            checked={checkSNS.no}
            onChange={() => setCheckSNS({ no: !checkSNS.no, yes: checkSNS.no })}
          >
            아니오
          </Checkbox>
        </div>

        {checkSNS.yes && (
          <div style={{ marginTop: "1rem" }}>
            <TextInput
              maxLength={300}
              control={control}
              name="sns_link"
              label="SNS 계정 정보"
              placeholder="SNS 계정 정보 입력"
            />
          </div>
        )}
      </section>

      <section>
        <label>세이브더얼스 공모전 참가경로 (필수)</label>

        <ToolWrapper>
          <Radio.Group
            name="contact_path"
            value={contactPath.find(c => c.value)?.name}
            onChange={e => {
              const selectedName = e.target.value;

              setContactPath(
                contactPath.map(c => ({
                  ...c,
                  value: c.name === selectedName,
                })),
              );
            }}
          >
            {contactPath.map(contact => (
              <Radio
                style={{
                  minWidth: "10rem",
                }}
                key={contact.name}
                value={contact.name}
              >
                {contact.name}
              </Radio>
            ))}
          </Radio.Group>
        </ToolWrapper>

        {contactPath.find(c => c.name === "기타")?.value && (
          <div style={{ marginTop: "1rem" }}>
            <TextInput
              control={control}
              name="contact_path_etc"
              label="공고를 확인한 매체"
              placeholder="예) 인스타그램, 유튜브, 카페(이름), 사이트(이름)"
              maxLength={50}
            />
          </div>
        )}
      </section>
    </CheckboxWrapper>
  );
};

export default CampaignCheckBoxGroup;
